var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.533,
    height: 16.906,
    viewBox: "0 0 17.533 16.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#596778;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.584,16.907H1.948A1.917,1.917,0,0,1,0,15.028V.94A.944.944,0,0,1,.652.053,1,1,0,0,1,.973,0a.982.982,0,0,1,.761.353L4.87,4.132,8.005.353a1.033,1.033,0,0,1,1.521,0l3.136,3.779L15.8.353A.987.987,0,0,1,16.56,0a1.011,1.011,0,0,1,.32.052.945.945,0,0,1,.653.887V15.028A1.917,1.917,0,0,1,15.584,16.907ZM1.948,13.15h0v1.878H15.585V13.15Zm0-9.533v7.654H15.585V3.617l-2.16,2.605a1.033,1.033,0,0,1-1.523,0L8.766,2.444,5.632,6.223a1.033,1.033,0,0,1-1.523,0Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTicket);
export default __webpack_public_path__ + "static/media/ico-ticket.670b1c165473a8716892f55e9b2ac86c.svg";
export { ForwardRef as ReactComponent };